var map = {
	".": 59,
	"./": 59,
	"./icons/100hp/1.svg": 776,
	"./icons/123slots/1.svg": 777,
	"./icons/18peaches/1.svg": 778,
	"./icons/18peaches/3.png": 779,
	"./icons/all/1.svg": 780,
	"./icons/amatic/1.svg": 781,
	"./icons/amatic/3.png": 782,
	"./icons/amigogaming/1.svg": 783,
	"./icons/amusnet/1.svg": 784,
	"./icons/apollo/1.svg": 785,
	"./icons/apollo/3.png": 786,
	"./icons/apollo/4.png": 787,
	"./icons/aristocrat/1.svg": 788,
	"./icons/aristocrat/3.png": 789,
	"./icons/austria/1.svg": 790,
	"./icons/austria/3.png": 791,
	"./icons/aviator/1.svg": 792,
	"./icons/aviatrix/1.svg": 793,
	"./icons/aviatrix/2.svg": 794,
	"./icons/aviatrix/3.png": 795,
	"./icons/aviatrix/4.png": 796,
	"./icons/belatra/1.svg": 797,
	"./icons/belatra/3.png": 798,
	"./icons/betconstruct/1.svg": 799,
	"./icons/betongames/1.svg": 800,
	"./icons/betsoft/1.svg": 801,
	"./icons/betsoft/3.png": 802,
	"./icons/betsoft/4.png": 803,
	"./icons/betsolutions/1.svg": 804,
	"./icons/betsolutions/3.png": 805,
	"./icons/betsolutions/4.png": 806,
	"./icons/bgaming/1.svg": 807,
	"./icons/bgaming/2.svg": 808,
	"./icons/bgaming/3.png": 809,
	"./icons/bgaming/4.png": 810,
	"./icons/bigtimegaming/1.svg": 811,
	"./icons/bigtimegaming/2.svg": 812,
	"./icons/bigtimegaming/3.png": 813,
	"./icons/bigtimegaming/4.png": 814,
	"./icons/bluejack/1.svg": 815,
	"./icons/booongo/1.svg": 816,
	"./icons/booongo/3.png": 817,
	"./icons/bsw/1.svg": 818,
	"./icons/bsw/3.png": 819,
	"./icons/bsw/4.png": 820,
	"./icons/bswgames/1.svg": 821,
	"./icons/bswgames/3.png": 822,
	"./icons/bswgames/4.png": 823,
	"./icons/casimi/1.svg": 824,
	"./icons/casimi/3.png": 825,
	"./icons/casinotechnology/1.svg": 826,
	"./icons/casinotechnology/3.png": 827,
	"./icons/casinotechnology/4.png": 828,
	"./icons/conceptgaming/1.svg": 829,
	"./icons/conceptgaming/3.png": 830,
	"./icons/cqgaming/1.svg": 831,
	"./icons/cqgaming/3.png": 832,
	"./icons/digitain/1.svg": 833,
	"./icons/dlv/1.svg": 834,
	"./icons/dlv/3.png": 835,
	"./icons/egt/1.svg": 836,
	"./icons/egt/3.png": 837,
	"./icons/elbet/1.svg": 838,
	"./icons/elbet/3.png": 839,
	"./icons/endorphina/1.svg": 840,
	"./icons/endorphina/3.png": 841,
	"./icons/endorphina/4.png": 842,
	"./icons/evolution/1.svg": 843,
	"./icons/evolution/3.png": 844,
	"./icons/evolution/4.png": 845,
	"./icons/evolutionlive/1.svg": 846,
	"./icons/evolutionlive/3.png": 847,
	"./icons/evolutionlive/4.png": 848,
	"./icons/evoplay/1.svg": 849,
	"./icons/evoplay/3.png": 850,
	"./icons/evoplay/4.png": 851,
	"./icons/ezugi/1.svg": 852,
	"./icons/ezugi/2.svg": 853,
	"./icons/ezugi/3.png": 854,
	"./icons/ezugi/4.png": 855,
	"./icons/favorite/1.svg": 856,
	"./icons/fiable/1.svg": 857,
	"./icons/fiable/3.png": 858,
	"./icons/fiable/4.png": 859,
	"./icons/fishing/1.svg": 860,
	"./icons/fishing/2.svg": 861,
	"./icons/fishing/3.png": 862,
	"./icons/fishing/4.png": 863,
	"./icons/flg/1.png": 864,
	"./icons/flg/2.svg": 865,
	"./icons/fugaso/1.svg": 866,
	"./icons/fugaso/2.svg": 867,
	"./icons/fugaso/3.png": 868,
	"./icons/fugaso/4.png": 869,
	"./icons/galaxsys/1.svg": 870,
	"./icons/galaxsys/3.png": 871,
	"./icons/gameart/1.svg": 872,
	"./icons/gameart/3.png": 873,
	"./icons/gaminator/1.svg": 874,
	"./icons/gaminator/3.png": 875,
	"./icons/gammatrade/1.svg": 876,
	"./icons/gamomat/1.svg": 877,
	"./icons/gamomat/3.png": 878,
	"./icons/ganapati/1.svg": 879,
	"./icons/ganapati/2.svg": 880,
	"./icons/ganapati/3.png": 881,
	"./icons/ganapati/4.png": 882,
	"./icons/golden_race/1.png": 883,
	"./icons/golden_race/3.png": 884,
	"./icons/greentube/1.svg": 885,
	"./icons/greentube/3.png": 886,
	"./icons/habanero/1.svg": 887,
	"./icons/habanero/3.png": 888,
	"./icons/habanero/4.png": 889,
	"./icons/hacksaw/1.svg": 890,
	"./icons/hacksaw/2.svg": 891,
	"./icons/hacksaw/3.png": 892,
	"./icons/hacksaw/4.png": 893,
	"./icons/igrosoft/1.svg": 894,
	"./icons/igrosoft/3.png": 895,
	"./icons/igt/1.svg": 896,
	"./icons/igt/3.png": 897,
	"./icons/inbet/1.svg": 898,
	"./icons/inbet/3.png": 899,
	"./icons/inout/1.svg": 900,
	"./icons/inout/2.svg": 901,
	"./icons/inout/3.png": 902,
	"./icons/inout/4.png": 903,
	"./icons/jacktop/1.png": 904,
	"./icons/kagaming/1.svg": 905,
	"./icons/kagaming/3.png": 906,
	"./icons/kagaming/4.png": 907,
	"./icons/kajot/1.svg": 908,
	"./icons/kajot/2.svg": 909,
	"./icons/kajot/3.png": 910,
	"./icons/kajot/4.png": 911,
	"./icons/konami/1.svg": 912,
	"./icons/konami/3.png": 913,
	"./icons/line1x/1.svg": 914,
	"./icons/lottoinstantwin/1.svg": 915,
	"./icons/lottoinstantwin/2.svg": 916,
	"./icons/lottoinstantwin/3.png": 917,
	"./icons/lottoinstantwin/4.png": 918,
	"./icons/luckygames/1.svg": 919,
	"./icons/luckygames/3.png": 920,
	"./icons/macawgaming/1.svg": 921,
	"./icons/macawgaming/2.svg": 922,
	"./icons/macawgaming/3.png": 923,
	"./icons/macawgaming/4.png": 924,
	"./icons/mascot/1.svg": 925,
	"./icons/mascot/2.svg": 926,
	"./icons/merkur/1.svg": 927,
	"./icons/merkur/3.png": 928,
	"./icons/merkur/4.png": 929,
	"./icons/microgaming/1.svg": 930,
	"./icons/microgaming/3.png": 931,
	"./icons/mrslotty/1.svg": 932,
	"./icons/mrslotty/3.png": 933,
	"./icons/netent/1.svg": 934,
	"./icons/netent/3.png": 935,
	"./icons/nolimit/1.svg": 936,
	"./icons/nolimit/3.png": 937,
	"./icons/nolimit/4.png": 938,
	"./icons/outcome/1.svg": 939,
	"./icons/outcome/3.png": 940,
	"./icons/pgsoft/1.svg": 941,
	"./icons/pgsoft/2.svg": 942,
	"./icons/pgsoft/3.png": 943,
	"./icons/pgsoft/4.png": 944,
	"./icons/pgsoftoriginal/1.svg": 945,
	"./icons/pgsoftoriginal/2.svg": 946,
	"./icons/pgsoftoriginal/3.png": 947,
	"./icons/pgsoftoriginal/4.png": 948,
	"./icons/platipus/1.svg": 949,
	"./icons/platipus/3.png": 950,
	"./icons/playngo/1.svg": 951,
	"./icons/playngo/3.png": 952,
	"./icons/playson/1.svg": 953,
	"./icons/playson/3.png": 954,
	"./icons/playson/4.png": 955,
	"./icons/playtech/1.svg": 956,
	"./icons/playtech/3.png": 957,
	"./icons/popokgaming/1.svg": 958,
	"./icons/pragmatic/1.svg": 959,
	"./icons/pragmatic/3.png": 960,
	"./icons/pragmatic/4.png": 961,
	"./icons/pragmaticlive/1.svg": 962,
	"./icons/pragmaticlive/3.png": 963,
	"./icons/pragmaticlive/4.png": 964,
	"./icons/pushgaming/1.svg": 965,
	"./icons/pushgaming/2.svg": 966,
	"./icons/pushgaming/3.png": 967,
	"./icons/pushgaming/4.png": 968,
	"./icons/quickspin/1.svg": 969,
	"./icons/quickspin/3.png": 970,
	"./icons/redrake/1.svg": 971,
	"./icons/redrake/3.png": 972,
	"./icons/reelnrg/1.svg": 973,
	"./icons/reelnrg/3.png": 974,
	"./icons/relaxgaming/1.svg": 975,
	"./icons/relaxgaming/2.svg": 976,
	"./icons/relaxgaming/3.png": 977,
	"./icons/relaxgaming/4.png": 978,
	"./icons/revolvergaming/1.svg": 979,
	"./icons/revolvergaming/3.png": 980,
	"./icons/rgs/1.svg": 981,
	"./icons/rgs/2.svg": 982,
	"./icons/rubiplay/1.png": 983,
	"./icons/rubyplay/1.png": 984,
	"./icons/slotegrator/1.svg": 985,
	"./icons/slotegrator/3.png": 986,
	"./icons/slotegrator/4.png": 987,
	"./icons/smartsoft/1.svg": 988,
	"./icons/softgaming/1.svg": 989,
	"./icons/softgaming/3.png": 990,
	"./icons/softgaming/4.png": 991,
	"./icons/softgamingslots/1.svg": 992,
	"./icons/softgamingslots/3.png": 993,
	"./icons/softgamingslots/4.png": 994,
	"./icons/spadegaming/1.svg": 995,
	"./icons/spadegaming/3.png": 996,
	"./icons/spinmatic/1.svg": 997,
	"./icons/spinmatic/3.png": 998,
	"./icons/spinomenal/1.svg": 999,
	"./icons/spinomenal/3.png": 1000,
	"./icons/spinomenal/4.png": 1001,
	"./icons/spribe/1.svg": 1002,
	"./icons/spribe/2.svg": 1003,
	"./icons/spribe/3.png": 1004,
	"./icons/spribe/4.png": 1005,
	"./icons/ssg/1.svg": 1006,
	"./icons/ssg/3.png": 1007,
	"./icons/tomhorn/1.png": 1008,
	"./icons/tomhorn/3.png": 1009,
	"./icons/tomhorn/4.png": 1010,
	"./icons/tvbet/1.svg": 1011,
	"./icons/tvbet/3.png": 1012,
	"./icons/tvbet/4.png": 1013,
	"./icons/ultim8/1.svg": 1014,
	"./icons/unicum/1.svg": 1015,
	"./icons/unicum/3.png": 1016,
	"./icons/unicum/4.png": 1017,
	"./icons/universalrace/1.svg": 1018,
	"./icons/upgaming/1.svg": 1019,
	"./icons/upgaming/3.png": 1020,
	"./icons/upgaming/4.png": 1021,
	"./icons/vivogaming/1.svg": 1022,
	"./icons/vivogaming/2.svg": 1023,
	"./icons/vivogaming/3.png": 1024,
	"./icons/vivogaming/4.png": 1025,
	"./icons/wacs/1.svg": 1026,
	"./icons/wacs/2.svg": 1027,
	"./icons/wacs/3.png": 1028,
	"./icons/wacs/4.png": 1029,
	"./icons/wazdan/1.svg": 1030,
	"./icons/wazdan/3.png": 1031,
	"./icons/wazdan/4.png": 1032,
	"./icons/winfinity/1.svg": 1033,
	"./icons/winfinity/2.svg": 1034,
	"./icons/winfinity/3.png": 1035,
	"./icons/winfinity/4.png": 1036,
	"./icons/winfinitylive/1.svg": 1037,
	"./icons/winfinitylive/2.svg": 1038,
	"./icons/winfinitylive/3.png": 1039,
	"./icons/winfinitylive/4.png": 1040,
	"./icons/winfinitylivecasino/1.svg": 1041,
	"./icons/winfinitylivecasino/2.svg": 1042,
	"./icons/winfinitylivecasino/3.png": 1043,
	"./icons/winfinitylivecasino/4.png": 1044,
	"./icons/winfinityslots/1.svg": 1045,
	"./icons/winfinityslots/2.svg": 1046,
	"./icons/winfinityslots/3.png": 1047,
	"./icons/winfinityslots/4.png": 1048,
	"./icons/wmg/1.svg": 1049,
	"./icons/wmg/3.png": 1050,
	"./icons/worldmatch/1.svg": 1051,
	"./icons/worldmatch/2.svg": 1052,
	"./icons/worldmatch/3.png": 1053,
	"./icons/worldmatch/4.png": 1054,
	"./icons/xpg/1.svg": 1055,
	"./icons/xpg/3.png": 1056,
	"./icons/xpg/4.png": 1057,
	"./index": 59,
	"./index.js": 59,
	"./list": 64,
	"./list.js": 64
};
var fakeMap = {
	"59": 9,
	"64": 9,
	"776": 7,
	"777": 7,
	"778": 7,
	"779": 7,
	"780": 7,
	"781": 7,
	"782": 7,
	"783": 7,
	"784": 7,
	"785": 7,
	"786": 7,
	"787": 7,
	"788": 7,
	"789": 7,
	"790": 7,
	"791": 7,
	"792": 7,
	"793": 7,
	"794": 7,
	"795": 7,
	"796": 7,
	"797": 7,
	"798": 7,
	"799": 7,
	"800": 7,
	"801": 7,
	"802": 7,
	"803": 7,
	"804": 7,
	"805": 7,
	"806": 7,
	"807": 7,
	"808": 7,
	"809": 7,
	"810": 7,
	"811": 7,
	"812": 7,
	"813": 7,
	"814": 7,
	"815": 7,
	"816": 7,
	"817": 7,
	"818": 7,
	"819": 7,
	"820": 7,
	"821": 7,
	"822": 7,
	"823": 7,
	"824": 7,
	"825": 7,
	"826": 7,
	"827": 7,
	"828": 7,
	"829": 7,
	"830": 7,
	"831": 7,
	"832": 7,
	"833": 7,
	"834": 7,
	"835": 7,
	"836": 7,
	"837": 7,
	"838": 7,
	"839": 7,
	"840": 7,
	"841": 7,
	"842": 7,
	"843": 7,
	"844": 7,
	"845": 7,
	"846": 7,
	"847": 7,
	"848": 7,
	"849": 7,
	"850": 7,
	"851": 7,
	"852": 7,
	"853": 7,
	"854": 7,
	"855": 7,
	"856": 7,
	"857": 7,
	"858": 7,
	"859": 7,
	"860": 7,
	"861": 7,
	"862": 7,
	"863": 7,
	"864": 7,
	"865": 7,
	"866": 7,
	"867": 7,
	"868": 7,
	"869": 7,
	"870": 7,
	"871": 7,
	"872": 7,
	"873": 7,
	"874": 7,
	"875": 7,
	"876": 7,
	"877": 7,
	"878": 7,
	"879": 7,
	"880": 7,
	"881": 7,
	"882": 7,
	"883": 7,
	"884": 7,
	"885": 7,
	"886": 7,
	"887": 7,
	"888": 7,
	"889": 7,
	"890": 7,
	"891": 7,
	"892": 7,
	"893": 7,
	"894": 7,
	"895": 7,
	"896": 7,
	"897": 7,
	"898": 7,
	"899": 7,
	"900": 7,
	"901": 7,
	"902": 7,
	"903": 7,
	"904": 7,
	"905": 7,
	"906": 7,
	"907": 7,
	"908": 7,
	"909": 7,
	"910": 7,
	"911": 7,
	"912": 7,
	"913": 7,
	"914": 7,
	"915": 7,
	"916": 7,
	"917": 7,
	"918": 7,
	"919": 7,
	"920": 7,
	"921": 7,
	"922": 7,
	"923": 7,
	"924": 7,
	"925": 7,
	"926": 7,
	"927": 7,
	"928": 7,
	"929": 7,
	"930": 7,
	"931": 7,
	"932": 7,
	"933": 7,
	"934": 7,
	"935": 7,
	"936": 7,
	"937": 7,
	"938": 7,
	"939": 7,
	"940": 7,
	"941": 7,
	"942": 7,
	"943": 7,
	"944": 7,
	"945": 7,
	"946": 7,
	"947": 7,
	"948": 7,
	"949": 7,
	"950": 7,
	"951": 7,
	"952": 7,
	"953": 7,
	"954": 7,
	"955": 7,
	"956": 7,
	"957": 7,
	"958": 7,
	"959": 7,
	"960": 7,
	"961": 7,
	"962": 7,
	"963": 7,
	"964": 7,
	"965": 7,
	"966": 7,
	"967": 7,
	"968": 7,
	"969": 7,
	"970": 7,
	"971": 7,
	"972": 7,
	"973": 7,
	"974": 7,
	"975": 7,
	"976": 7,
	"977": 7,
	"978": 7,
	"979": 7,
	"980": 7,
	"981": 7,
	"982": 7,
	"983": 7,
	"984": 7,
	"985": 7,
	"986": 7,
	"987": 7,
	"988": 7,
	"989": 7,
	"990": 7,
	"991": 7,
	"992": 7,
	"993": 7,
	"994": 7,
	"995": 7,
	"996": 7,
	"997": 7,
	"998": 7,
	"999": 7,
	"1000": 7,
	"1001": 7,
	"1002": 7,
	"1003": 7,
	"1004": 7,
	"1005": 7,
	"1006": 7,
	"1007": 7,
	"1008": 7,
	"1009": 7,
	"1010": 7,
	"1011": 7,
	"1012": 7,
	"1013": 7,
	"1014": 7,
	"1015": 7,
	"1016": 7,
	"1017": 7,
	"1018": 7,
	"1019": 7,
	"1020": 7,
	"1021": 7,
	"1022": 7,
	"1023": 7,
	"1024": 7,
	"1025": 7,
	"1026": 7,
	"1027": 7,
	"1028": 7,
	"1029": 7,
	"1030": 7,
	"1031": 7,
	"1032": 7,
	"1033": 7,
	"1034": 7,
	"1035": 7,
	"1036": 7,
	"1037": 7,
	"1038": 7,
	"1039": 7,
	"1040": 7,
	"1041": 7,
	"1042": 7,
	"1043": 7,
	"1044": 7,
	"1045": 7,
	"1046": 7,
	"1047": 7,
	"1048": 7,
	"1049": 7,
	"1050": 7,
	"1051": 7,
	"1052": 7,
	"1053": 7,
	"1054": 7,
	"1055": 7,
	"1056": 7,
	"1057": 7
};

function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, fakeMap[id]);
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context */ 2).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 580;
module.exports = webpackAsyncContext;